import { render, staticRenderFns } from "./CounselingMessages.vue?vue&type=template&id=1da45550"
import script from "./CounselingMessages.vue?vue&type=script&lang=js"
export * from "./CounselingMessages.vue?vue&type=script&lang=js"
import style0 from "./CounselingMessages.vue?vue&type=style&index=0&id=1da45550&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports